import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import AgencyStore from "../../../Store/AgencyStore";
import CareGiverStore from "../../../Store/CareGiverStore";
import ClientStore from "../../../Store/ClientStore";
import NurseAndCareGiverPopUp from "../../../NurseAndCareGiver/Document/NurseAndCareGiverPopUp";
import Icon from "../../../components/Icons/Icon";
const NurseAndCareGiverDocViewerList = observer(
  ({
    govResultSet,
    applicationResumeAndHireResultSet,
    confidentialResultSet,
  }) => {
    const downloadPDF = (data, fileName) => {
      AgencyStore.downloadFile(data, fileName);
    };
    const openPdf = (data) => {
      AgencyStore.openPDF(data);
    };

    const addNewFile = (data) => {
      CareGiverStore.setFileUploadPopUp(true);
      CareGiverStore.setSelectedDoc(data);
    };

    const [responseData, setResponseData] = useState({});
    const careGiverAllDocList = CareGiverStore?.careGiverAllDocList;
    useEffect(() => {
      if (govResultSet === "govResultSet") {
        setResponseData(careGiverAllDocList?.govResultSet);
      } else if (confidentialResultSet === "confidentialResultSet") {
        setResponseData(careGiverAllDocList?.confidentialResultSet);
      } else if (
        applicationResumeAndHireResultSet == "applicationResumeAndHireResultSet"
      ) {
        setResponseData(careGiverAllDocList?.applicationResumeAndHireResultSet);
      }
    }, [
      govResultSet,
      applicationResumeAndHireResultSet,
      confidentialResultSet,
      careGiverAllDocList,
      ClientStore?.clientAllDocList,
    ]);

    return (
      <div className="docviewMainContainer">
        {/* {CareGiverStore.isUniqueCodeEntered === false ? (
          <div className="listMainDivContainer enterCodeContainer">
            <div>
              <FormikController
                name="uniqueCode"
                error
                label="Unique Code"
                type="text"
                control="textfield"
                {...formik.getFieldProps("uniqueCode")}
                touch={formik.touched.uniqueCode}
                errorname={formik.errors.uniqueCode}
              />
            </div>
            <FormikController
              name="Submit code"
              control="buttons"
              onClick={formik.handleSubmit}
              className="buttonSelected fixedWidth"
              fullWidth="false"
            />
          </div>
        ) : ( */}

        {responseData && (
          <div className="listMainDivContainer">
            {Object.entries(responseData).map(([key, documents]) => (
              <div key={key} className="docDetailsMainContainer">
                <div className="docTypeTitle">
                  <div>{key}</div>
                  <NurseAndCareGiverPopUp
                    uniqueNameType={key}
                    clickHTML={
                      <div className="docAddContainer">
                        <AiOutlinePlusCircle className="docAddIcon" /> Add New
                      </div>
                    }
                  />
                </div>
                {documents.map((document) => (
                  <div
                    key={document.id}
                    className={`docDetailsContainer ${
                      document?.isAdminApproved == true ? "" : "notApproved"
                    }`}
                  >
                    <div className="docDetailsLeftContainer">
                      <div className="docIconContainer">
                        <Icon iconName="pdf" />
                      </div>
                      <div>
                        <div
                          className={`docTitle ${
                            document.isAdminApproved == true
                              ? ""
                              : "notApprovedDocTitle"
                          } `}
                        >
                          {document.fileName}
                        </div>
                        <div className="docSubTitlemainContainer">
                          <div className="dovViewerDateContainer">
                            Uploaded Date:{document.docUploadedDate}
                          </div>
                          {document.fileExpiryDate && (
                            <div className="dovViewerDateContainer">
                              Expiry Date: {document.fileExpiryDate}
                            </div>
                          )}

                          <div
                            className="boderRoundedButton"
                            onClick={() => {
                              downloadPDF(document.filePath, document.fileName);
                            }}
                          >
                            <Icon
                              iconName="pdf2"
                              className="boderRoundedButtonIcon"
                            />
                            <span className="boderRoundedButtonText">
                              Download
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="boderRoundedButton"
                      onClick={() => {
                        openPdf(document.filePath);
                      }}
                    >
                      <Icon
                        iconName="view"
                        className="boderRoundedButtonIconGreen"
                      />

                      <span className="boderRoundedButtonText">View</span>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
);

export default NurseAndCareGiverDocViewerList;
